import type { ErrorEvent } from '@sentry/vue'

// Sentry's server-side N+1 detector mistakes normal map asset fan-out for API calls.
// Filter after completion so failed/unfinished requests remain available for diagnosis.
export const ignoreSuccessfulMapAssetSpans = [
  {
    op: /^http\.client$/,
    name: /^GET https:\/\/api\.mapbox\.com\/(?:styles\/v1|fonts\/v1|v4)\//,
    attributes: { 'http.response.status_code': 200 },
  },
]

// Matches the Vite chunk that bundles mapbox-gl (`/build/assets/mapbox-<hash>.js`) and the
// package path Sentry shows once source maps resolve it.
const MAPBOX_FRAME = /\/assets\/mapbox-[\w-]+\.js|\/node_modules\/mapbox-gl\//

/**
 * Groups errors thrown inside Mapbox by error type and message. Without this, every release
 * opens new issues because the chunk hash and minified function names in the stack change.
 */
export function fingerprintMapboxErrors(event: ErrorEvent): ErrorEvent {
  const exception = event.exception?.values?.at(-1)
  const crashFrame = exception?.stacktrace?.frames?.at(-1)
  const path = crashFrame?.abs_path ?? crashFrame?.filename

  if (exception && path && MAPBOX_FRAME.test(path)) {
    event.fingerprint = ['mapbox-gl', exception.type ?? 'Error', exception.value ?? '']
  }

  return event
}
